import { Anchor, Badge, Box, Grid, Group, Image, Stack, Text } from '@mantine/core';
import { useParams } from 'react-router';

const ProductDetailsCard = (entry) => {
  const { accountId, domainId } = useParams();
  const product = entry?.hit?._source;
  const productScore = entry?.hit?._score;
  const productMetrics = entry?.hit?.productMetrics;
  const countMetrics = entry?.metrics;
  const href = `#/accounts/${accountId}/domains/${domainId}/products/${product.id}`;

  return (
    <Grid.Col span={{ base: 12, md: 3 }}>
      <Stack gap="xs" align="center" style={{ borderRight: '1px solid rgba(136, 136, 136, 0.2)', height: '100%' }}>
        <Box style={{ width: '100%', maxWidth: 150, aspectRatio: '1', overflow: 'hidden' }}>
          <Image
            src={product?.imageUrl}
            alt={product?.name}
            referrerPolicy="no-referrer"
            fit="contain"
            h={150}
          />
        </Box>

        <Stack gap={4} align="center" style={{ flex: 1 }}>
          <Text size="xs" c="dimmed">{product?.id}</Text>
          <Text
            size="sm"
            fw={600}
            ta="center"
            lineClamp={2}
            style={{ minHeight: 40 }}
          >
            <Anchor href={href} c="inherit">
              {product?.name}
            </Anchor>
          </Text>
          {product?.available ? (
            <Badge color="green" variant="light" size="sm">In stock</Badge>
          ) : (
            <Badge color="red" variant="light" size="sm">Out of stock</Badge>
          )}
          {product?.discountPrice ? (
            <Stack gap={0} align="center">
              <Text size="xs" td="line-through" c="dimmed">
                {product?.listPrice + ' ' + product?.currency}
              </Text>
              <Text size="sm" fw={600} c="red">
                {product?.discountPrice + ' ' + product?.currency}
              </Text>
            </Stack>
          ) : (
            <Text size="sm" fw={500}>
              {product?.listPrice + ' ' + product?.currency}
            </Text>
          )}
        </Stack>

        <Group
          gap="md"
          justify="center"
          pt="xs"
          style={{ borderTop: '1px solid rgba(136, 136, 136, 0.2)', width: '100%' }}
        >
          <Stack gap={0} align="center">
            <Text size="xs" c="dimmed">{countMetrics[0].title}</Text>
            <Text size="sm" fw={600}>{productScore}</Text>
          </Stack>
          {productMetrics?.quantity !== undefined && (
            <Stack gap={0} align="center">
              <Text size="xs" c="dimmed">Quantity</Text>
              <Text size="sm" fw={600}>{productMetrics.quantity}</Text>
            </Stack>
          )}
          {productMetrics?.revenue !== undefined && (
            <Stack gap={0} align="center">
              <Text size="xs" c="dimmed">Revenue</Text>
              <Text size="sm" fw={600}>{productMetrics.revenue}</Text>
            </Stack>
          )}
          {!productMetrics && countMetrics[1] && (
            <Stack gap={0} align="center">
              <Text size="xs" c="dimmed">{countMetrics[1].title}</Text>
              <Text size="sm" fw={600}>{countMetrics[1].count}</Text>
            </Stack>
          )}
        </Group>
      </Stack>
    </Grid.Col>
  );
};

export default ProductDetailsCard;
